// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2a8_v","subheader":"ReorderModal_subheader__11A0o","listWrap":"ReorderModal_listWrap__1ZK1q"};